<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-button
          v-if="isSuperuser"
          class="mr-3"
          @click="editPlaceNameClicked"
        >
          {{ $t('edit-place-name') }}
        </b-button>
      </b-col>
    </b-row>
    <place-name-edit-modal ref="placeNameEditModal" />
  </div>
</template>

<script>
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import PlaceNameEditModal from '@/components/places/PlaceNameEditModal';
import { mapGetters } from 'vuex';

export default {
  name: 'ServiceGroups',
  components: { PlaceNameEditModal },
  mixins: [
    BaseContextMenuMixin,
  ],
  computed: {
    ...mapGetters({
      isSuperuser: 'user/isSuperuser',
    }),
  },
  methods: {
    editPlaceNameClicked() {
      this.$refs.placeNameEditModal.show();
    },
  },
};
</script>

<style scoped>

</style>
